// Helpers for property URL slugs
export const slugify = (text = "") =>
  text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 70);

// Build a property URL: /propiedad/<title-slug>-<short-id>
export const propertyPath = (property) => {
  if (!property?.id) return "/gallery";
  const titleSlug = slugify(property.title || "propiedad");
  return `/propiedad/${titleSlug}-${property.id}`;
};

// UUID v4 regex (the trailing 36 chars of our slugs)
const UUID_RE =
  /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

// Extract the UUID from a slug like "campo-bla-103a4f4e-f642-43e6-86e2-e11032719eda"
export const extractIdFromSlug = (slug = "") => {
  const match = slug.match(UUID_RE);
  return match ? match[1] : slug;
};
